import React from "react"
import Snackbar from "../../components/snackbar/snackbar"

export default ({ slice }) => {
  const { read_more_link, messaging } = slice.primary

  return <Snackbar readMoreLink={read_more_link} messaging={messaging} />
}
